var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGriffleBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1025.2 947.133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.25 204.53C136.06 164.365 151.036 131.993 157.026 119.404C185.98 58.8571 245.084 35.4776 262.456 28.4838C312.975 8.30145 357.902 12.6976 381.065 15.2953C406.224 18.0929 436.775 28.4838 496.878 49.0657C571.158 74.6433 572.156 78.8396 595.119 81.2375C648.433 87.0325 659.815 66.2507 715.325 63.6529C736.89 62.6538 815.563 59.057 872.072 113.609C907.215 147.38 937.367 206.927 923.389 260.281C910.21 310.437 866.88 321.227 872.072 351.201C878.861 389.368 950.545 379.776 984.89 428.933C1025.03 486.482 1000.07 605.178 933.573 653.336C875.067 695.699 803.782 669.722 778.223 717.88C762.449 747.654 783.016 769.834 766.443 788.218C736.491 821.389 661.412 757.045 577.348 773.631C483.699 792.015 489.689 889.13 400.034 918.704C289.812 955.072 150.637 850.963 83.545 757.445C72.5627 742.258 -19.0893 614.37 24.8398 544.831C57.3872 493.476 134.063 521.452 194.765 449.515C202.353 440.523 248.878 385.571 232.904 339.611C220.724 304.442 180.788 299.846 153.832 241.297C145.445 222.314 143.049 208.726 142.25 204.53Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4",
    x: 4.13381e-8,
    y: -6.8792e-8,
    width: 1025.2,
    height: 947.133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.168627 0 0 0 0 0.0313726 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriffleBlob);
export default __webpack_public_path__ + "static/media/griffle-blob.57b7d1d88f7c20533e842e96876be4c6.svg";
export { ForwardRef as ReactComponent };